
// src/actions/permanent-store.js

function json_parse(value) {
  try {
    return JSON.parse(value)
  }
  catch(e) {
    return JSON.parse(`"${value}"`)
  }
}

export default function(key, defaut_value = undefined) {
  return {
    get: (callback)=> {
      const value = localStorage.getItem(key)
      callback(value && json_parse(value) || defaut_value)
    },

    set: (value, callback)=> {
      localStorage.setItem(key, JSON.stringify(value))
      if (callback) callback(value)
    },

    clear: ()=> {
      localStorage.removeItem(key)
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/permanent-store.js